import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { NavLink } from 'react-router-dom';
import { ExternalLink, Pencil } from 'lucide-react';
import { regulationWindowUrl } from './WindowSession';

/** The ordinary link keeps its width; secondary actions live in its menu. */
export function RegulationLink({ projectId, regulationId, title, onEdit }: { projectId:number; regulationId:number; title:string; onEdit?: () => void }) {
  const [menu,setMenu]=useState<{x:number;y:number}|null>(null);
  const link=useRef<HTMLAnchorElement>(null);
  const surface=useRef<HTMLDivElement>(null);
  const action=useRef<HTMLButtonElement>(null);
  useEffect(()=>{
    if (!menu) return;
    action.current?.focus();
    const outside=(event:PointerEvent)=>{if(event.target instanceof Node && !surface.current?.contains(event.target))setMenu(null);};
    const keyboard=(event:KeyboardEvent)=>{
      if(event.key==='Escape'){event.preventDefault();setMenu(null);link.current?.focus();}
      else if(event.key==='Tab')setMenu(null);
    };
    const close=()=>setMenu(null);
    document.addEventListener('pointerdown',outside);
    document.addEventListener('keydown',keyboard);
    window.addEventListener('blur',close);
    window.addEventListener('resize',close);
    window.addEventListener('scroll',close,true);
    return ()=>{document.removeEventListener('pointerdown',outside);document.removeEventListener('keydown',keyboard);window.removeEventListener('blur',close);window.removeEventListener('resize',close);window.removeEventListener('scroll',close,true);};
  },[menu]);
  const open=(x:number,y:number)=>setMenu({x:Math.max(8,Math.min(x,window.innerWidth-256)),y:Math.max(8,Math.min(y,window.innerHeight-(onEdit ? 108 : 60)))});
  return <>
    <NavLink ref={link} to={`/projects/${projectId}/assets/${regulationId}`} aria-haspopup="menu" aria-expanded={!!menu} title={onEdit ? 'Удерживайте и перетащите для смены порядка. Правой кнопкой — действия.' : 'Правой кнопкой — открыть в новом окне'}
      onContextMenu={event=>{event.preventDefault();const rect=event.currentTarget.getBoundingClientRect();open(event.clientX||rect.left,event.clientY||rect.bottom);}}
      onKeyDown={event=>{if(event.key==='ContextMenu'||event.key==='F10'&&event.shiftKey){event.preventDefault();const rect=event.currentTarget.getBoundingClientRect();open(rect.left,rect.bottom);}}}>{title}</NavLink>
    {menu&&createPortal(<div ref={surface} className="regulation-window-menu" role="menu" aria-label={`Действия с регламентом ${title}`} style={{left:menu.x,top:menu.y}}>
      <button ref={action} type="button" role="menuitem" onClick={()=>{window.open(regulationWindowUrl(projectId,regulationId),'_blank','popup=yes,noopener,width=1280,height=900');setMenu(null);}}><ExternalLink size={17}/><span>Открыть в новом окне</span></button>
      {onEdit && <button type="button" role="menuitem" className="sc-menu-edit" onClick={() => { setMenu(null); onEdit(); }}><Pencil size={17}/><span>Редактировать</span></button>}
    </div>,document.body)}
  </>;
}
